import styled from 'styled-components';

export const BreadcrumbsContainer = styled.div`
    list-style: none;
    margin: 15px auto 30px;
    font-size: 10px;

    span a[disabled] {
        opacity: 1;
    }

    .separator {
        margin: 0 5px;
    }

    a {
        font-size: 10px;
        color: ${props => props.theme.breadcrumbColor};
        text-decoration: none;
    }

    a:last-child,
    a:hover {
        text-decoration: underline;
    }
`;



// WEBPACK FOOTER //
// ./src/components/breadcrumb/BreadcrumbComponentStyle.js